<template>
  <main class="app-container">
    <div :style="`height: ${height}px;`">
      <md-scroll-view
              ref="scrollView"
              :scrolling-x="false"
              @end-reached="onReachBottom"
      >
        <activity-filter @onSearch="onSearch"/>

        <list-loading v-show="listData.loading && listData.query.page == 1" />
        <div class="no-result" v-show="!listData.loading && listData.data.length < 1">暂无数据</div>

        <div class="p10">
          <activity-item
                  v-for="item in listData.data"
                  :key="item.id"
                  :activity="item"
                  @onImageLoad="imageLoad"
          />
        </div>


        <md-scroll-view-more
                slot="more"
                finished-text=""
                :is-finished="listData.hasNextPage == false"
        >
        </md-scroll-view-more>
      </md-scroll-view>
    </div>

    <tab-bar></tab-bar>
  </main>
</template>

<script>
import ActivityFilter from "../components/ActivityFilter.vue";
import ActivityItem from "../components/ActivityItem.vue";
import ListLoading from "../components/ListLoading.vue";
import listDataMixin from "../mixins/list-data";
import {ScrollView, ScrollViewMore} from 'mand-mobile'
import TabBar from "../components/TabBar"

export default {
  components: {
      ActivityFilter,ActivityItem,ListLoading,TabBar,
      [ScrollView.name]: ScrollView,
      [ScrollViewMore.name]: ScrollViewMore,
  },
    mixins: [listDataMixin],
    methods: {
        onSearch(filter) {
            console.log(filter);
            this.initListData();
            const {query} = this.listData;
            this.listData.query = {...query, ...filter};
            console.log(this.listData.query);
            this.loadListData();
        },
        imageLoad() {
            this.reflow();
        },

    },
    data() {
        return {
            height: window.screen.height,
            apiEndpoint: 'activities',
            pageSize: 10,
        }
    },
    created() {
        this.loadListData();
    },
    mounted() {
        console.log('mounted');
        console.log(document.querySelector("#ch-tab-bar").offsetHeight);
        this.height = window.screen.height - document.querySelector("#ch-tab-bar").offsetHeight;
    },
};
</script>


<style lang="scss" scoped>


</style>
